
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useTina } from "tinacms/dist/react";
import client from "../../../../tina/__generated__/client";
import Post from "../../../components/blog/BlogPost";
const BlogPage = (props) => {
    const { data } = useTina({
        query: props.query,
        variables: props.variables,
        data: props.data,
    });
    if (!data) {
        return null;
    }
    return <Post {...data.post}/>;
};
export const getStaticPaths = async () => {
    const postConnection = await client.queries.postConnection();
    const basePaths = [];
    postConnection.data.postConnection.edges.map((post) => {
        const breadcrumbs = post.node._sys.breadcrumbs; // e.g. ["openings", "fried-liver-attack"]
        const category = breadcrumbs[0];
        const filename = breadcrumbs[1];
        const locale = post.node.locale || "en";
        basePaths.push({
            params: {
                category,
                slug: filename,
            },
            locale,
        });
    });
    const paths = basePaths;
    return {
        paths,
        fallback: true,
    };
};
const getStaticProps = async ({ params }) => {
    const { category, slug } = params;
    const variables = {
        relativePath: `${category}/${slug}.mdx`,
    };
    const props = await client.queries.post(variables);
    return {
        props: { ...props },
    };
};
export default BlogPage;

    async function __Next_Translate__getStaticProps__19db5234f64__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/[category]/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19db5234f64__ as getStaticProps }
  